import Storage from '@/utils/Storage'

let sessionSelectedEventAction = window.sessionStorage.getItem('selectedEventAction')
let authData = window.sessionStorage.getItem('authData')
const networkingHistory = Storage.get('networkingHistory') || []

try {
    if (sessionSelectedEventAction) {
        sessionSelectedEventAction = JSON.parse(sessionSelectedEventAction)
    } else {
        sessionSelectedEventAction = null
    }

    if (authData) {
        authData = JSON.parse(authData)
    } else {
        authData = null
    }
} catch (e) {
    console.warn(e)
    sessionSelectedEventAction = null
}

export default () => ({
    leadPayload: null,
    suggestedEvents: [],
    networkingHistory,
    eventActions: null,
    selectedEventAction: sessionSelectedEventAction || null,
    liveAuthData: authData || null,
    liveSchedule: null,
    loading: {
        eventActions: false,
        physicalEvents: false,
        streamingEvents: false,
        physicalEventsInHub: false,
        physicalEventsOutHub: false,
        pastEvents: false,
    },
    myEvents: {
        current: [],
        passed: [],
    },
    upcomingEvents: {
        totalResultCount: 0,
        events: [],
    },
    pastEvents: {
        totalResultCount: 0,
        events: [],
    },
    searchedEvents: {
        physicalEvents: {
            nbResults: 0,
            results: [],
            currentPage: 1,
        },
        streamingEvents: {
            nbResults: 0,
            results: [],
            currentPage: 1,
        },
        physicalEventsInHub: {
            nbResults: 0,
            results: [],
            currentPage: 1,
        },
        physicalEventsOutHub: {
            nbResults: 0,
            results: [],
            currentPage: 1,
        },
        pastEvents: {
            nbResults: 0,
            results: [],
            currentPage: 1,
        },
    },
    showSearchedEvents: false,
    searchEventTypeFilter: null,
    searchParameters: {
        businessCenters: [],
        city: '',
        startDate: '',
        endDate: '',
        search: '',
        placeId: '',
    },
})
